import { render, staticRenderFns } from "./InvoiceButtons.vue?vue&type=template&id=35b25116&scoped=true"
import script from "./InvoiceButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceButtons.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceButtons.vue?vue&type=style&index=0&id=35b25116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b25116",
  null
  
)

export default component.exports